'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--AircraftLanding';

var EntypoAircraftLanding = function EntypoAircraftLanding(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M18.752,16.038c-0.097,0.266-0.822,1.002-6.029-0.878l-5.105-1.843C5.841,12.676,3.34,11.668,2.36,11.1c-0.686-0.397-0.836-1.282-0.836-1.282S1.361,6.862,1.261,6.134c-0.1-0.728,0.095-0.853,0.796-0.492c0.436,0.225,1.865,2.562,2.464,3.567C6.033,9.59,7.383,9.97,8.014,10.158C7.757,8.441,7.274,5.23,7.101,4.225C6.935,3.262,7.651,3.69,7.651,3.69c0.331,0.19,0.983,0.661,1.206,1.002c1.522,2.326,3.672,6.6,3.836,6.928c0.896,0.28,2.277,0.733,3.102,1.03C17.951,13.429,18.882,15.684,18.752,16.038z' })
    );
};

exports.default = EntypoAircraftLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/AircraftLanding.js
// module id = ./node_modules/react-entypo/lib/entypo/AircraftLanding.js
// module chunks = 2